import { render, staticRenderFns } from "./newHome.vue?vue&type=template&id=43080a9a&"
import script from "./newHome.vue?vue&type=script&lang=js&"
export * from "./newHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports